import type { RaceTrait } from "@/lib/race-traits"
import { cn } from "@/lib/utils"

interface TraitBadgeProps {
  trait: RaceTrait
  className?: string
}

const TRAIT_STYLES: Record<RaceTrait, string> = {
  Bashy:
    "bg-[oklch(0.25_0.1_28)] text-[oklch(0.72_0.18_28)] border-[oklch(0.35_0.12_28)]",
  Agile:
    "bg-[oklch(0.22_0.08_155)] text-[oklch(0.72_0.14_155)] border-[oklch(0.32_0.1_155)]",
  Balanced:
    "bg-[oklch(0.22_0.06_250)] text-[oklch(0.72_0.12_250)] border-[oklch(0.32_0.08_250)]",
  Stunty:
    "bg-[oklch(0.25_0.1_85)] text-[oklch(0.72_0.14_85)] border-[oklch(0.35_0.1_85)]",
  Resilient:
    "bg-[oklch(0.22_0.06_290)] text-[oklch(0.7_0.1_290)] border-[oklch(0.32_0.08_290)]",
}

export function TraitBadge({ trait, className }: TraitBadgeProps) {
  return (
    <span
      className={cn(
        "border px-2 py-0.5 text-[10px] font-bold tracking-widest uppercase",
        TRAIT_STYLES[trait],
        className,
      )}
    >
      {trait}
    </span>
  )
}
